function toggleTreeSubmenu(arrow) {
  const submenu = arrow.closest('.parent-tree-item')?.nextElementSibling;

  if (submenu?.tagName !== 'UL') {
    return;
  }

  const isHidden = getComputedStyle(submenu).display === 'none';

  submenu.style.display = isHidden ? 'block' : 'none';
  arrow.classList.toggle('expanded', isHidden);
}

document.addEventListener('click', function (e) {
  const arrow = e.target.closest('.arrow');

  if (arrow) {
    toggleTreeSubmenu(arrow);
    return;
  }

  const toggleOnlyParent = e.target.closest('.parent-tree-item--toggle-only');

  if (toggleOnlyParent) {
    const parentArrow = toggleOnlyParent.querySelector('.arrow');

    if (parentArrow) {
      toggleTreeSubmenu(parentArrow);
    }

    return;
  }

  if (e.target.closest('.custom-qty-plus')) {
    const wrap = e.target.closest('.custom-qty-wrap');
    const input = wrap.querySelector('.custom-qty');
    input.value = parseInt(input.value || 1, 10) + 1;
  }

  if (e.target.closest('.custom-qty-minus')) {
    const wrap = e.target.closest('.custom-qty-wrap');
    const input = wrap.querySelector('.custom-qty');
    const current = parseInt(input.value || 1, 10);

    if (current > 1) {
      input.value = current - 1;
    }
  }
});

(function () {
  let addToQuoteTimer = null;

  function getStoreifyForm() {
    const modal = document.querySelector('#storeify-chooseproduct-modal');
    return (
      modal?.querySelector('.storeify-form-action-quote') ||
      document.querySelector('.storeify-form-action-quote')
    );
  }

  function buildQuoteBodyHtml(handle, title, image, variantId, price, qty) {
    return `
      <div class="ify-product-head">
        <input type="hidden" value="${handle}" id="ify_handle_txt">

        <div class="ify-product-thumbnail">
          <img class="storeify-thumbnail" src="${image}">
        </div>
      </div>

      <div class="ify-product-body">
        <h5 class="variant-title">${title}</h5>

        <div
          class="storeify-frm-group storeify-div-select storeify-div-input storeify-option-variants"
          style="display:none;"
        >
          <select
            id="storeify_option_variants"
            class="storeify-input-control storeify-select form-control-select"
          >
            <option
              selected="selected"
              value="${variantId}"
              data-pricedefault="${price}"
              data-price="${price}"
              data-img="${image}"
              data-name="${title}"
            >
              Default Title
            </option>
          </select>
        </div>

        <div class="storeify-frm-group storeify-col-1 ify_qty_group">
          <div class="storeify-div-input">
            <input
              type="text"
              class="storeify-input-control storeify-input-text ify_qty_input"
              value="${qty}"
            >
          </div>
        </div>
      </div>
    `;
  }

  function syncStoreifyFields(body) {
    const variantSelect = body.querySelector('#storeify_option_variants');
    const handleInput = body.querySelector('#ify_handle_txt');
    const qtyField = body.querySelector('.ify_qty_input');

    if (variantSelect) {
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (handleInput) {
      handleInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (qtyField) {
      qtyField.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  function resetStoreifySubmitButton(submitBtn, qty) {
    submitBtn.disabled = false;
    submitBtn.removeAttribute('disabled');
    submitBtn.style.removeProperty('display');
    submitBtn.setAttribute('data-qty', qty);

    if (window.jQuery) {
      window.jQuery(submitBtn).prop('disabled', false).show().attr('data-qty', qty);
    }
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.custom-add-to-quote-btn');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const wrapper = btn.closest('.custom-quote-data');
    if (!wrapper) return;

    const handle = wrapper.dataset.handle;
    const title = wrapper.dataset.title;
    const image = wrapper.dataset.image;
    const variantId = wrapper.dataset.variantId;
    const price = wrapper.dataset.price;
    const qtyInput = wrapper.querySelector('.custom-qty');
    const qty = qtyInput ? qtyInput.value : '1';

    const form = getStoreifyForm();
    if (!form) return;

    const body = form.querySelector('.storeify-body-frm');
    if (!body) return;

    if (addToQuoteTimer) {
      clearTimeout(addToQuoteTimer);
    }

    body.innerHTML = buildQuoteBodyHtml(handle, title, image, variantId, price, qty);
    syncStoreifyFields(body);

    addToQuoteTimer = setTimeout(function () {
      addToQuoteTimer = null;

      const submitBtn = form.querySelector('.storeify-add-to-quote');
      if (!submitBtn) return;

      resetStoreifySubmitButton(submitBtn, qty);

      if (window.jQuery) {
        window.jQuery(submitBtn).trigger('click');
      } else {
        submitBtn.click();
      }
    }, 50);
  });
})();
